
import { Vue, Component, Prop } from 'vue-property-decorator'
import helpCenter from '@/components/help-center.vue'
import Disclaimer from './disclaimer.vue'
import { State } from 'vuex-class'

@Component({
  name: 'QualificationLayout',
  components: {
    helpCenter,
    Disclaimer
  },
  filters: {}
})
export default class Qualification extends Vue {
  @Prop({ type: Boolean, default: false }) loading: boolean
  @Prop({ type: Number, default: 0 }) formIndex: number
  @Prop({ type: String, default: 'Comfirm' }) sureText: string
  @Prop({ type: String, default: 'title' }) titleText: string
  @State('asyncFnInprogress', { namespace: 'qualification' })
  asyncFnInprogress: boolean

  get submitBtnDisabled() {
    return this.loading || this.asyncFnInprogress
  }

  onBackClick() {
    this.$emit('handleBack')
  }
  onSureClick() {
    this.$emit('handleOk')
  }
}
